import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

require('./mock'); //引入mock数据，关闭则注释该行

import '@/styles/index.scss' // global css
import '@/styles/date-time-picker.scss' // date-time-picker css
// import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './icons' // icon

import './plugins/axios' //插件-网络请求库
import './plugins/element.js' //插件-element ui
import './plugins/common.js' //公共函数
import './plugins/platform.js' //多平台相关函数
import './plugins/permission.js' //权限处理函数
import './plugins/drag.js' //自定义命令-弹窗拖拽
import './directives' //自定义命令
import './filter' //自定义过滤
import './components' //组件
import './plugins/echarts' //插件-图表
import './plugins/guide' //插件-初次使用引导
import './plugins/dayjs' //插件-dayjs 时间处理类库
// import './plugins/nedb' //插件-nedb 数据库
import './plugins/vxetable' //插件-vxe-table

import jquery from 'jquery'
window.jquery = window.$ = jquery

import 'babel-polyfill';

import Meta from 'vue-meta'; //管理 HMTL 头部标签
Vue.use(Meta)
Vue.config.productionTip = false

new Vue({
  router, store,
  render: h => h(App)
}).$mount('#app')